module.exports = __webpack_public_path__ + "img/linkxr.3847130d.jpg";